// Libraries
var React = require('react');
var dateFormat = require('dateformat');

// Styles
require('./FixtureItem.scss');

// Components
var CallToAction = require('CallToAction/CallToAction');
var ConditionalWrapper = require('../../common/ConditionalWrapper/ConditionalWrapper');

// Assets
var placeholder = require('images/transparent1px.png');

const Crest = ({crest, shortName}) => (
		<div className="home">
			{crest &&
					<img src={placeholder} data-src={crest.smallUrl} alt={crest.altText} />
			}
			<p>{shortName}</p>
		</div>
);

const FixtureCrests = props => (
	<div className="FixtureItem__crests">
		<Crest crest={props.homeTeamCrest} shortName={props.homeTeamShort} />
		{props.scores}
		<Crest crest={props.awayTeamCrest} shortName={props.awayTeamShort} />
	</div>
);

const FixtureKickoff = ({mdcLink, kickoff, kickoffDay}) => (
	<div className="FixtureItem__kickoff">
		{mdcLink ? (
			<a href={mdcLink.url}>
				<p>{kickoffDay}</p>
				{kickoff}
				{/* Span expands link to the entire expanded block */}
				<span></span>
			</a>
		) : (
			<div>
				<p>{kickoffDay}</p>
				{kickoff}
			</div>
		)}
	</div>
);

const StadiumType = ({stadiumType}) => (
		<div className={"stadium-tag stadium-tag--" + stadiumType.toLowerCase()}>
			<span>
				<abbr title={stadiumType}>
					{stadiumType[0].toUpperCase()}
				</abbr>
			</span>
		</div>
);

class FixtureItemModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			open: this.props.data.isNextFixture,
			kickoff: "",
			kickoffDay: ""
		};

		this.fixture = this.props.data.fixture
	}

	componentDidMount() {
		// delay this until the component mounts on the client side
		// to avoid server side / client side local time mismatching
		this.setState({
			kickoffDay: (this.fixture.kickOffOverrideText ? '' : dateFormat(this.fixture.kickOff, "dddd")), 
			kickoff: this.fixture.kickOffOverrideText || dateFormat(this.fixture.kickOff, "dd mmm, HH:MM")
		});
	};

	componentWillReceiveProps({data}) {
		if(!data.fixture.kickOffOverrideText && data.fixture.kickOff !== this.fixture.kickOff) {
			this.setState({kickoff: dateFormat(data.fixture.kickOff, "dd mmm, HH:MM")});
		}
	}

	toggleExpandedView = event => {
		this.setState({open: !this.state.open});
	};

	render() {
		const fixture = this.fixture;

		const stadiumType = 
			fixture.stadiumType && fixture.stadiumType.toLowerCase() !== 'neutral' &&
				<StadiumType stadiumType={fixture.stadiumType} />;

		const scores = fixture.isFullTime &&
			fixture.homeScore !== null &&
			fixture.awayScore !== null ? (
				<div className="scores">
					{fixture.homeScore} - {fixture.awayScore}
					{fixture.aggregateHomeScore !== null && fixture.aggregateAwayScore !== null &&
						<span className="score-extra">
							(Agg {fixture.aggregateHomeScore}-{fixture.aggregateAwayScore})
						</span>
					}

					{fixture.penaltyHomeScore !== null && fixture.penaltyAwayScore !== null &&
						<span className={"score-extra" + (fixture.aggregateAwayScore ? " score-extra-offset" : "")}>
							(Pen {fixture.penaltyHomeScore}-{fixture.penaltyAwayScore})
						</span>
					}
				</div>
			) : (
				<div className="scores">VS
					{fixture.aggregateHomeScore !== null && fixture.aggregateAwayScore !== null && (
						<span className="score-extra">
							(Agg {fixture.aggregateHomeScore}-{fixture.aggregateAwayScore})
						</span>
					)}
				</div>
			);

		const fixtureCrests = (
			<FixtureCrests
				homeTeamCrest={fixture.homeTeam.darkCrest}
				homeTeamShort={fixture.homeTeam.shortName}
				awayTeamCrest={fixture.awayTeam.darkCrest}
				awayTeamShort={fixture.awayTeam.shortName}
				scores={scores}
			/>
		);

		const fixtureKickoff = (
			<FixtureKickoff
				mdcLink={fixture.matchDayCentreLink}
				kickoff={this.state.kickoff}
				kickoffDay={this.state.kickoffDay}
			/>
		);

		const oppositCrest = fixture[fixture.isHomeFixture ?
										"awayTeam" :
										"homeTeam"
									].darkCrest;

		const fixtureItemCTA = (
			<CallToAction ariaLabel={"Buy tickets for " + fixture.homeTeam.name + " vs " + fixture.awayTeam.name} button={true} {...fixture.buttonLink} />
		);

		return (
			<ConditionalWrapper condition={this.props.data.isOneHotspur} wrapper={children => <section className='c-fixture-item--one-hotspur c-section c-section--one-hotspur'>{children}</section>}>
				<div
					className={"FixtureItem " + (this.props.data.isFullWidth ? "fullWidth" : "")}
					tabIndex="0"
					title={fixture.homeTeam.name + " vs " + fixture.awayTeam.name}
				>

					{/* Mobile header */}
					<div className="FixtureItem__summary js-transition-summary" data-id={fixture.id}>
						<div className={"wrapper js-open-expanded" + (fixture.isMatchOccurring ? " match-occurring" : "")} onClick={this.toggleExpandedView}>
							{stadiumType}

							<div className="FixtureItem__summary--20">
								{!fixture.kickOffOverrideText &&
									<p className="kickoff">{dateFormat(fixture.kickOff, "dd")}</p>
								}
							</div>
							<div className="FixtureItem__summary--20">
								{oppositCrest &&
									<img src={placeholder} data-src={oppositCrest.url} alt={oppositCrest.altText} />
								}
							</div>
							<div className={"FixtureItem__summary--60" + (this.state.open ? " expanded-open" : "")}>
								<p>{fixture.competition.name}</p>
							</div>
						</div>
						{fixtureItemCTA}
					</div>

					{/* Mobile expanded content */}
					<div className={"FixtureItem__expanded js-transition-expanded" + (this.state.open ? " show" : "")} data-id={fixture.id}>
						<div className={"outer-wrapper"}>
							<div className={"wrapper" + (fixture.isMatchOccurring ? " match-occurring" : "")}>
								{fixtureCrests}

								{fixtureKickoff}

								<div className="FixtureItem__stadium">
									<p className="location">{fixture.stadium.displayName}</p>
								</div>

								{fixture.matchDayCentreLink &&
									<span className="FixtureItem__link">{fixture.matchDayCentreLink.caption}</span>
								}
							</div>
						</div>
					</div>

					{/* Desktop */}
					<div className={"FixtureItem__desktop"}>
						<div className={"wrapper" + (fixture.isMatchOccurring ? " match-occurring" : "")}>
							{stadiumType}

							{fixtureKickoff}

							{fixtureCrests}

							<div className="FixtureItem__stadium">
								<p>{fixture.competition.name}</p>
								{fixture.competitionStage &&
									<p className="stage">{fixture.competitionStage}</p>
								}
								<p className="location">{fixture.stadium.displayName}</p>
							</div>
							{fixture.matchDayCentreLink &&
								<span className="FixtureItem__link">{fixture.matchDayCentreLink.caption}</span>
							}
						</div>
						<div className="FixtureItem__cta">
							{fixtureItemCTA}
						</div>
					</div>
				</div>
			</ConditionalWrapper>
		)
	}
}

module.exports = FixtureItemModule;



// WEBPACK FOOTER //
// ./src/components/Fixtures/FixtureItemModule.js